<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-advances d-lg-inline-block"></div>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>{{ getTitle }}</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form name="exemption"
                                      method="post"
                                      enctype="multipart/form-data"
                                      novalidate="novalidate"
                                      class="needs-validation"
                                >
                                    <!-- Client name -->
                                    <label class="required-field-asterisks required"
                                           for="enterprise-name">Nom du Client
                                    </label>
                                    <input type="text"
                                           id="enterprise-name"
                                           class="form-control form-control-lg"
                                           placeholder="Nom du Client"
                                           :class="{ 'is-invalid': $v.formData.name.$error }"
                                           v-model="formData.name"
                                           @input="delayTouch($v.formData.name)"
                                    >
                                    <FormError error="Veuillez renseigner le nom"
                                               v-if="$v.formData.name.$error"
                                    ></FormError>
                                    <!-- Client name -->

                                    <!-- Employees quantity -->
                                    <label class="required-field-asterisks required"
                                           for="employees-quantity">Nombre de salariés
                                    </label>
                                    <input type="number"
                                           id="employees-quantity"
                                           class="form-control form-control-lg"
                                           placeholder="Nombre de salariés"
                                           v-model.number="formData.employeesQuantity"
                                    >
                                    <!-- Employees quantity -->

                                    <!-- DUE checkbox -->
                                    <div class="check-container">
                                        <!-- checkbox -->
                                        <div class="form-group clearfix">
                                            <div class="icheck-primary d-inline">
                                                <input type="checkbox"
                                                       id="paper-due-exists"
                                                       v-model="formData.isPaperDueExists"
                                                >
                                                <label for="paper-due-exists">
                                                    <span>DUE présente en dehors d'AFFLEX</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- DUE checkbox -->
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto login-btn__wrapper">
                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled="isLoading || $v.$invalid"
                                    @click.prevent="submit"
                            >
                                <span>Enregistrer</span>
                                <ButtonSpinner :isLoading="isLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import FormError from '../../components/FormError';
    import ButtonSpinner from '../../components/ButtonSpinner';
    import ValidationDelayTouch from '../../mixins/validationDelayTouch';
    import EnterpriseManager from '../../service/manager/enterpriseManager';
    import { required, email } from 'vuelidate/lib/validators';
    import { createEnterprise, updateEnterprise } from '../../service/api/enterprise.api';
    import { mapActions, mapGetters } from "vuex";
    import { errorMessage, successMessage, messageTexts } from "@/utils/sweet-alert-options";

    export default {
        mixins: [ValidationDelayTouch],
        data() {
            return {
                formData: {
                    name: '',
                    employeesQuantity: null,
                    isPaperDueExists: false
                },
                isLoading: false,
                uuid: null,
                createTitle: 'Créer une Entreprise',
                updateTitle: 'Modifier l\'entreprise',
                enterprise: null
            };
        },
        async created() {
          await this.fetchUpdatedEnterprise();
        },
        computed: {
            ...mapGetters({
                updatedEnterprise: 'updatedEnterprise',
            }),
            getTitle() {
                return this.isUpdatedEnterpriseExist() ? this.updateTitle :this.createTitle;
            }
        },
        methods: {
            ...mapActions({
                clearUpdatedEnterpriseData: 'clearUpdatedEnterpriseData'
            }),
            async submit() {
                try {
                    this.isLoading = true;

                    this.isUpdatedEnterpriseExist()
                        ? await updateEnterprise(
                            await EnterpriseManager.createFromFormData(this.formData),
                            this.enterprise.uuid
                        )
                        : await createEnterprise(
                            await EnterpriseManager.createFromFormData(this.formData)
                        );

                    this.isLoading = false;
                    const message = this.isUpdatedEnterpriseExist()
                        ? messageTexts.updateEnterpriseSuccess
                        : messageTexts.createEnterpriseSuccess
                    ;

                    this.$swal({ title: message, ...successMessage });

                    setTimeout(() => {
                      this.$router.push({ name: 'enterprise-list'});
                    }, 3000);
                } catch ({ response }) {
                    this.isLoading = false;

                    this.$swal({ title: messageTexts.createOrUpdateEnterpriseError, ...errorMessage });
                }
            },
            async fetchUpdatedEnterprise() {
                this.enterprise = this.updatedEnterprise;

                if (this.enterprise) {
                    this.formData = {
                        ...this.formData,
                        ... await EnterpriseManager.createEditFormData(this.enterprise)
                    };
                }
            },
            isUpdatedEnterpriseExist() {
                return this.enterprise && this.enterprise.uuid;
            }
        },
        beforeRouteLeave (to, from, next) {
            if (this.isUpdatedEnterpriseExist()) {
                this.clearUpdatedEnterpriseData()
            }

            next();
        },
        validations: {
            formData: {
                name: {
                    required
                },
                email: {
                    email
                },
                employeesQuantity: {
                    required
                }
            }
        },
        components: {
            Footer,
            Sidebar,
            FormError,
            ButtonSpinner
        }
    }
</script>